import { isEmptyResponse } from "./util.js";
import { AbortError } from "../../../nodemodules/@jwplayer/fe-common/module/util/error/index.js";

//#region ../base/fetch/xhr.ts
var AbortError$1 = class extends AbortError {
	xhr;
	evt;
	constructor({ xhr, evt }) {
		super();
		this.xhr = xhr;
		this.evt = evt;
	}
};
var XhrError = class extends Error {
	name = "XhrError";
	message = "XHR Error";
	xhr;
	data;
	evt;
	headers;
	constructor({ xhr, data, evt, headers }) {
		super("XHR Error");
		this.xhr = xhr;
		this.data = data;
		this.evt = evt;
		this.headers = headers;
	}
};
const parseHeaders = (request) => {
	const headers = request.getAllResponseHeaders();
	const arr = headers.trim().split(/[\r\n]+/);
	return arr.reduce((acc, line) => {
		const parts = line.split(": ");
		const header = parts.shift()?.trim();
		const value = parts.join(": ");
		acc[header] = value;
		return acc;
	}, {});
};
async function httpPut(url, blob, opts) {
	const fileArr = new Uint8Array(await blob.arrayBuffer());
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.open("PUT", url);
		xhr.overrideMimeType("application/json");
		for (const [key, value] of Object.entries(opts?.headers ?? {})) xhr.setRequestHeader(key, value);
		if (opts?.authToken) xhr.setRequestHeader("Authorization", opts.authToken);
		if (opts?.onProgress) xhr.upload.addEventListener("progress", (e) => {
			const completion = e.loaded / e.total;
			opts.onProgress?.(completion);
		});
		if (opts?.signal) {
			const abort = () => {
				xhr.abort();
			};
			opts.signal.addEventListener("abort", abort);
			xhr.addEventListener("readystatechange", () => {
				if (xhr.readyState === 4) opts.signal?.removeEventListener("abort", abort);
			});
			xhr.addEventListener("abort", (evt) => {
				reject(new AbortError$1({
					xhr,
					evt
				}));
			});
		}
		xhr.addEventListener("load", (evt) => {
			let json;
			if (!isEmptyResponse(xhr)) try {
				json = JSON.parse(xhr.responseText);
			} catch (err) {}
			const headers = parseHeaders(xhr);
			if (xhr.status >= 200 && xhr.status < 400) resolve({
				xhr,
				json,
				headers
			});
			else reject(new XhrError({
				xhr,
				data: json,
				evt,
				headers
			}));
		});
		xhr.addEventListener("error", (evt) => {
			reject(new XhrError({
				xhr,
				evt
			}));
		});
		xhr.addEventListener("timeout", (evt) => {
			reject(new XhrError({
				xhr,
				evt
			}));
		});
		xhr.send(fileArr);
	});
}

//#endregion
export { httpPut };
//# sourceMappingURL=xhr.js.map